import React from 'react';
import { Stack, Text } from '@moda/om';
import { PageMeta } from '../../components/PageMeta';
import { useScrollHashReferenceToView } from '../../hooks/useScrollHashReferenceToView';

import './LegalTradeMarksPage.scss';

export const LegalTradeMarksPage = () => {
  useScrollHashReferenceToView();
  return (
    <>
      <PageMeta title="LegalTradeMarksPage" />

      <div className="LegalTradeMarksPage">
        <div className="LegalTradeMarksPage__title">
          <Text treatment="h3">Moda Operandi Trademarks</Text>
        </div>
        <Stack space={4}>
          <Stack className="LegalTradeMarksPage__section" space={4}>
            <Text treatment="body2" family="serif">
              The following is a non-exhaustive list of Moda Operandi’s trademarks in the United
              States. A trademark can be a word, phrase, symbol, or design that distinguishes the
              source of the goods or services. As trade dress, it can also be the appearance of a
              product or its packaging (for example, size, shape, color, texture, graphics) and
              appearance (such as a showroom, website, or mobile application). In addition, Moda
              Operandi may have some or all of the below-listed marks registered in one or more
              other countries and regions.
            </Text>
            <Text treatment="body2" family="serif">
              Please note that the absence of a product or service name or logo from this list, or
              the absence of a trademark symbol (for example, ™, ℠, or ®), is not a waiver of any of
              Moda Operandi’s trademark or other intellectual property rights.
            </Text>
            <Text className="LegalTradeMarksPage__underlined" treatment="body2" family="serif">
              Moda Operandi Trademarks:
            </Text>
            <Text treatment="body2" family="serif">
              Moda Operandi
            </Text>
            <Text treatment="body2" family="serif">
              Moda Domus
            </Text>
            <Text treatment="body2" family="serif">
              Moda Private
            </Text>
            <Text treatment="body2" family="serif">
              Moda Rewards
            </Text>
            <Text treatment="body2" family="serif">
              M.O
            </Text>
            <div className="LegalTradeMarksPage__image">
              <img src="/dist/public/modashapes.svg" alt="moda shapes" />
            </div>
          </Stack>
        </Stack>
      </div>
    </>
  );
};
